import React, { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import { singleImageUpload } from "../../../Hooks/ImageUpload";
import PostHooks from "../../../Hooks/PostHooks";
import UpdateHooks from "../../../Hooks/UpdateHooks";
import JoditEditor from "jodit-react";
import { Icon } from "@iconify/react";
import { useQuery } from "../../../Hooks/useApi";

const SuperAdminGrow = () => {
  const { data: growResponse } = useQuery("/grow/getGrow");
  const [imageUrl, setImageUrl] = useState("");
  const [formData, setFormData] = useState({
    title: "",
    content: "",
  });
  const editor = useRef(null);

  useEffect(() => {
    if (growResponse?.data?.length) {
      setFormData(growResponse.data[0]);
      setImageUrl(growResponse.data[0]?.img || "");
    }
  }, [growResponse]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      if (formData?._id) {
        await UpdateHooks(
          `https://servercareseebd.careseebd.com/api/v1/grow/updateGrow/${formData?._id}`,
          { ...formData, img: imageUrl }
        );
        toast.success("Grow section updated successfully!");
      } else {
        await PostHooks(
          `https://servercareseebd.careseebd.com/api/v1/grow/addGrow`,
          { ...formData, img: imageUrl },
          "grow data posted"
        );
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleChangeUploadImage = async (event) => {
    const image = event.target.files[0];
    const formData = new FormData();
    formData.append("image", image);
    singleImageUpload(formData, setImageUrl);
  };

  return (
    <div className="max-w-4xl mx-auto select-none space-y-6">
      {/* Header bar */}
      <div className="flex items-center gap-3 bg-white p-6 rounded-2xl border border-slate-100 shadow-sm">
        <div className="p-3 bg-indigo-50 text-indigo-600 rounded-xl">
          <Icon icon="solar:graph-up-bold" className="w-6 h-6" />
        </div>
        <div>
          <h1 className="text-lg font-black text-slate-800 tracking-tight">Grow Section Settings</h1>
          <p className="text-xs text-slate-400 font-semibold mt-0.5">Edit information banner details, images, and content descriptions</p>
        </div>
      </div>

      {/* Main card */}
      <div className="bg-white rounded-2xl border border-slate-100 shadow-sm p-6 lg:p-8">
        <form onSubmit={handleSubmit} className="space-y-5">
          <div className="space-y-1.5">
            <label className="block text-[11px] font-bold text-slate-500 uppercase tracking-wide">Section Banner Image</label>
            <div className="space-y-2">
              <input
                type="file"
                onChange={handleChangeUploadImage}
                className="w-full px-3 py-2 rounded-xl border border-slate-200 focus:outline-none focus:ring-2 focus:ring-indigo-500/20 focus:border-indigo-500 text-xs file:mr-3 file:py-1 file:px-2.5 file:rounded-md file:border-0 file:text-[10px] file:font-extrabold file:uppercase file:bg-indigo-50 file:text-indigo-700 hover:file:bg-indigo-100 cursor-pointer"
                accept="image/*"
              />
              {imageUrl && (
                <div className="w-24 h-24 rounded-xl border border-slate-100 overflow-hidden bg-slate-50 p-1 flex items-center justify-center">
                  <img className="max-w-full max-h-full object-contain rounded-lg" src={imageUrl} alt="preview" />
                </div>
              )}
            </div>
          </div>

          <div className="space-y-1.5">
            <label className="block text-[11px] font-bold text-slate-500 uppercase tracking-wide">Section Title</label>
            <input
              type="text"
              name="title"
              required
              onChange={handleChange}
              value={formData.title}
              placeholder="e.g. Grow your practice today"
              className="w-full px-3 py-2.5 rounded-xl border border-slate-200 focus:outline-none focus:ring-2 focus:ring-indigo-500/20 focus:border-indigo-500 text-xs font-semibold text-slate-800"
            />
          </div>

          <div className="space-y-1.5">
            <label className="block text-[11px] font-bold text-slate-500 uppercase tracking-wide">Grow Content Editor</label>
            <div className="rounded-xl overflow-hidden border border-slate-200">
              <JoditEditor
                ref={editor}
                value={formData?.content}
                onChange={(newContent) => {
                  setFormData((prev) => ({
                    ...prev,
                    content: newContent,
                  }));
                }}
              />
            </div>
          </div>

          <div className="pt-2">
            <button
              type="submit"
              className="w-full py-2.5 bg-gradient-to-r from-cyan-500 to-blue-600 hover:opacity-95 text-white font-extrabold text-xs rounded-xl shadow-md shadow-cyan-500/10 hover:-translate-y-0.5 transition-all duration-300 cursor-pointer"
            >
              Update Grow Section
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default SuperAdminGrow;
